import { useMutation, useQueryClient } from '@tanstack/react-query'
import { regenerateSoapFromAudio } from '@/shared/apis/yakureki'
import { queryKeys } from '@/shared/hooks/queries/queryKeys'
import { useToast } from '@/shared/contexts/ToastContext'

// 旧 path 専用 mutation (= 音声 reprocess / transcribe → SOAP の一気通貫).
// back guard: status==FAILED + regenerate_count<3. それ以外は HTTP error.
// apps/legacy 配下からのみ使用. toast 文言は legacy app の旧文言を維持.
export const useRegenerateFromAudioMutation = () => {
  const queryClient = useQueryClient()
  const { showToast } = useToast()

  return useMutation({
    mutationFn: async (yakurekiId: string) => {
      await regenerateSoapFromAudio(yakurekiId)
    },
    onSuccess: (_, yakurekiId) => {
      showToast('SOAP を再生成しています', 'info')
      queryClient.invalidateQueries({
        queryKey: queryKeys.yakureki.detail(yakurekiId),
      })
    },
    onError: (error) => {
      const axiosError = error as { response?: { status?: number } }
      const status = axiosError.response?.status
      if (status === 409) {
        showToast('再生成回数の上限 (3 回) に達しました', 'warning')
      } else if (status === 403) {
        showToast('再生成可能な薬歴ではありません', 'warning')
      } else if (status === 404) {
        showToast('指定された薬歴が見つかりません', 'error')
      } else if (!navigator.onLine) {
        showToast('ネットワーク接続を確認してください', 'error')
      } else {
        showToast('SOAP 再生成に失敗しました', 'error')
      }
    },
  })
}
